import ForecastMedia from "@/components/forecast-media";
import ForecastWidget from "@/components/skydata/forecast-widget";
import { useForecastQuery } from "@/query/forecast-query";
import { useParams } from "react-router-dom";

// Хотуудын нэрсийг тогтмол утгаар тодорхойлох
const CITY_NAMES = {
  ulaanbaatar: "Улаанбаатар",
  darkhan: "Дархан",
  erdenet: "Эрдэнэт",
} as const;

type CityType = keyof typeof CITY_NAMES;

const ForecastLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <div className="absolute inset-0 z-10 top-11">{children}</div>;
};
// Error/Loading states-г нэгтгэх
const ForecastStatus: React.FC<{ message: string }> = ({ message }) => (
  <ForecastLayout>
    <div className="flex items-center justify-center h-screen ">
      <div className="text-white text-xl">{message}</div>
    </div>
  </ForecastLayout>
);

const SkydataForecastPage: React.FC = () => {
  const { type } = useParams<{ type: string }>();

  // Type guard function
  const isCityType = (city: string | undefined): city is CityType => {
    return city !== undefined && city in CITY_NAMES;
  };

  // Хот танигдахгүй бол алдааны мэдээ харуулах
  if (!isCityType(type)) {
    return <ForecastStatus message={`Танигдахгүй хотын төрөл: ${type}`} />;
  }

  const title = CITY_NAMES[type];
  const { data, isLoading, error } = useForecastQuery(type);

  // Loading болон error state-уудыг шийдэх
  if (isLoading) {
    return <ForecastStatus message="Ачаалж байна..." />;
  }

  if (error) {
    return <ForecastStatus message="Алдаа гарлаа" />;
  }

  if (!data) {
    return <ForecastStatus message="Өгөгдөл олдсонгүй" />;
  }

  return (
    <ForecastLayout>
      <ForecastMedia media={data.media} title={title} />
      <ForecastWidget title={title} data={data} />
    </ForecastLayout>
  );
};

export default SkydataForecastPage;
